import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@/pwa/useOnlineStatus';

export function OfflineIndicator() {
  const { t } = useTranslation();
  const online = useOnlineStatus();

  if (online) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      padding: '6px 16px',
      backgroundColor: '#b45309',
      color: '#fffbeb',
      textAlign: 'center',
      fontSize: 'var(--font-size-base)',
      fontFamily: 'var(--font-family)',
      fontWeight: 500,
    }}>
      {t('offline.banner')}
    </div>
  );
}
